import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reasonText'
})
export class ReasonTextPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}
